// Statiske data for Vuba Helstøbt Stenbelægning

export const navigationLinks = [
  { name: 'Forside', path: '/' },
  {
    name: 'Belægninger',
    path: '#',
    children: [
      { name: 'Helstøbt Stenbelægning', path: '/helstoebt-stenbelaegning' },
      { name: 'Lodret Stenbelægning', path: '/lodret-stenbelaegning' },
      { name: 'Vuba Materialer', path: '/vuba-materialer' }
    ]
  },
  { name: 'Farver og Design', path: '/farver-og-design' },
  { name: 'Service', path: '/service' },
  { name: 'Referencer', path: '/referencer' },
  { name: 'Om os', path: '/om-os' },
  { name: 'Kontakt', path: '/kontakt' }
];

export const contactInfo = {
  phone: '+45 30 31 31 61',
  email: 'Info@StenB.dk',
  address: 'Syv Holmevej 16, 4130 Viby Sjælland',
  hours: 'Man - Fre: 08:00 - 16:00, Lør: Efter aftale',
  guarantee: '10 års garanti på alt udført arbejde'
};

export const applications = [
  {
    title: 'Indkørsler',
    description: 'En elegant og ekstremt slidstærk indkørsel, der tåler tung belastning fra biler uden spordannelse.',
    icon: 'Car'
  },
  {
    title: 'Terrasser',
    description: 'Skab en fugefri oase med et eksklusivt naturstensudtryk, der er behageligt at gå på med bare tæer.',
    icon: 'Sun'
  },
  {
    title: 'Gangstier',
    description: 'Flotte, drænende stier gennem haven eller rundt om huset, helt uden ukrudt eller løse sten.',
    icon: 'Footprints'
  },
  {
    title: 'Trapper',
    description: 'Renovering af slidte trapper med belægning på både trin og lodrette flader for et helstøbt udtryk.',
    icon: 'Layers'
  },
  {
    title: 'Poolområder & vådzoner',
    description: 'En skridsikker og drænende overflade, hvor vandet hurtigt siver igennem, så du undgår vandpytter.',
    icon: 'Waves'
  },
  {
    title: 'Garager & overdækkede arealer',
    description: 'En rengøringsvenlig og stærk overflade, der modstår olie, vejsalt og slid.',
    icon: 'Home'
  }
];

export const benefits = [
  {
    title: 'Eksklusivt udseende',
    description: 'Smukke natursten, der giver et luksuriøst og moderne udtryk til din ejendom.',
    icon: 'Sparkles'
  },
  {
    title: 'Skridsikker overflade',
    description: 'Selv i vådt vejr bevarer belægningen sin skridsikkerhed takket være stenenes struktur.',
    icon: 'ShieldCheck'
  },
  {
    title: 'Drænende løsning',
    description: 'Vandet siver direkte igennem belægningen (op til 850 liter pr. m² pr. minut) og aflaster kloakken.',
    icon: 'Droplet'
  },
  {
    title: 'Minimal vedligeholdelse',
    description: 'Ingen løse sten, der skal rives, og ingen fuger, hvor ukrudt kan slå rødder.',
    icon: 'CheckCircle'
  },
  {
    title: 'Ukrudtsfri belægning',
    description: 'Den fugefrie og tætte overflade forhindrer ukrudt i at vokse op nedefra.',
    icon: 'Leaf'
  },
  {
    title: 'Lang levetid & 10 års garanti',
    description: 'Vi anvender kun markedets stærkeste resin og yder hele 10 års garanti på alt udført arbejde.',
    icon: 'Award'
  }
];

export const serviceSteps = [
  {
    title: 'Gennemgang af belægningen',
    description: 'Vi inspicerer hele overfladen for eventuelle mekaniske skader eller sætninger i underlaget.'
  },
  {
    title: 'Professionel rensning',
    description: 'Dybdegående og skånsom rensning af overfladen, der fjerner snavs, alger og atmosfærisk smuds.'
  },
  {
    title: 'Kontrol af kanter og afslutninger',
    description: 'Vi sikrer, at alle kantskinner og overgange to andre belægninger er intakte og stabile.'
  },
  {
    title: 'Pleje og opfriskning',
    description: 'Påføring af et beskyttende plejelag (topcoat) efter behov, som genskaber glansen og styrken.'
  },
  {
    title: 'Rådgivning om vedligeholdelse',
    description: 'Du får professionelle råd til, hvordan du holder belægningen flot i hverdagen med minimal indsats.'
  }
];
